import React from 'react';
import { motion } from 'framer-motion';
import RouterOverview from './RouterOverview';
import RouterSpecsGrid from './RouterSpecsGrid';

/**
 * RouterFeaturesContent component
 * Displays the router features content tab
 */
const RouterFeaturesContent = ({ contentVariants }) => {
  return (
    <motion.div
      key="router-content"
      className="p-4 md:p-8"
      variants={contentVariants}
      initial="hidden"
      animate="visible"
      exit="exit"
    >
      <div className="max-w-7xl mx-auto">
        {/* Router Overview with Image and Free-to-Use Information */}
        <RouterOverview />

        {/* Router Specifications */}
        <RouterSpecsGrid />
      </div>
    </motion.div>
  );
};

export default RouterFeaturesContent;